import { Route } from '@angular/router';
// import { initialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from 'app/layout/layout.component';

import { AuthGuard } from './core/auth/guards/auth.guard';
import { NoAuthGuard } from './shared/guards/no-auth.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Sign In & Sign Up
    {
        path: 'auth',
        canActivate: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-in', loadChildren: () => import('app/pages/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/pages/auth/sign-up/sign-up.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/pages/auth/forgot-password/forgot-password.routes')},
            // Enlaces viejos de registro (`/auth/register?token=…`): el registro ya es de un solo
            // paso. El redirect conserva el token y sign-up lo usa si sigue vivo.
            {path: 'register', pathMatch: 'full', redirectTo: 'sign-up'},
            {path: 'reset-password', loadChildren: () => import('app/pages/auth/reset-password/reset-password.routes')},
            {path: 'terms', loadChildren: () => import('app/pages/auth/terms/terms.routes')},
        ]
    },

    // Protected routes for authenticated users
    {
        path: 'tandaplus',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'classy'
        },
        children: [
            { path: 'dashboard', loadChildren: () => import('app/pages/dashboard/dashboard.routes') },
            { path: 'nueva-tanda', loadChildren: () => import('app/pages/tanda/nueva-tanda/nueva-tanda.routes') },
            { path: 'tanda/:idu_tanda', loadChildren: () => import('app/pages/tanda/admin-tanda/admin-tanda.routes') },
            { path: 'contactos', loadChildren: () => import('app/pages/contactos/contactos.routes') },
            { path: 'articulos', loadChildren: () => import('app/pages/articulos/articulos.routes') },
            { path: 'historial-tandas', loadChildren: () => import('app/pages/historial-tandas/historial-tandas.routes') },
            { path: 'perfil', loadChildren: () => import('app/pages/perfil/perfil.routes') },
            { path: 'pro', loadChildren: () => import('app/pages/pro/pro.routes') },
            { path: 'mi-marca', loadChildren: () => import('app/pages/mi-marca/mi-marca.routes') },
            { path: 'novedades', loadChildren: () => import('app/pages/changelog/changelog.routes') },
            { path: 'mis-participaciones', loadChildren: () => import('app/pages/mis-participaciones/mis-participaciones.routes') },
            { path: 'comprobantes', loadChildren: () => import('app/pages/comprobantes/comprobantes.routes') },

            { path: '**', pathMatch: 'full', redirectTo: 'dashboard' }
        ]
    },

    // Email verification (public, no auth required)
    {
        path: 'auth/verify-email',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '', loadChildren: () => import('app/pages/auth/verify-email/verify-email.routes') }
        ]
    },

    // Public tanda view (no auth required)
    {
        path: 'tanda-publica/:idu_tanda',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '', loadChildren: () => import('app/pages/tanda-publica/tanda-publica.routes') }
        ]
    },

    // Estado de cuenta personal del participante (sin cuenta): es el destino
    // de los recordatorios de WhatsApp. Antes apuntaban a /tanda-publica/:id,
    // que se cierra justo cuando la tanda inicia — o sea, siempre que el
    // recordatorio existe.
    {
        path: 'mi-tanda/:token',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '', loadChildren: () => import('app/pages/mi-tanda/mi-tanda.routes') }
        ]
    },

    // Historial de puntualidad que un participante compartió (sin cuenta, sólo lectura)
    {
        path: 'puntualidad/:share_token',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '', loadChildren: () => import('app/pages/puntualidad/puntualidad.routes') }
        ]
    },

    // Public join-by-invite page (no auth required)
    {
        path: 'unirse/:token',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '', loadChildren: () => import('app/pages/unirse/unirse.routes') }
        ]
    },

    // Invitación para co-organizar (pública, sin guard): se ve sin sesión; para
    // aceptar se entra o se crea cuenta y se vuelve aquí (`redirectURL`). Es la
    // misma ruta que abre la app por universal links / App Links.
    {
        path: 'co-organizar/:token',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '', loadChildren: () => import('app/pages/co-organizar/co-organizar.routes') }
        ]
    },

    // "Agregarme" desde la página pública de la tanda: el mismo formulario,
    // por el id de la tanda en vez del token de invitación.
    {
        path: 'unirse-tanda/:idu_tanda',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { path: '', loadChildren: () => import('app/pages/unirse/unirse.routes') }
        ]
    },

    // Enlaces sin el prefijo /auth. La landing apuntaba aqui y el comodin de
    // abajo los mandaba a iniciar sesion: quien venia de "Registrate" aterrizaba
    // en un formulario pidiendole una contrasena que todavia no tenia. La landing
    // ya quedo corregida, pero estos alias se quedan porque hay enlaces sueltos
    // en redes, en buscadores y en mensajes ya enviados que no se pueden corregir.
    { path: 'sign-up', pathMatch: 'full', redirectTo: 'auth/sign-up' },
    { path: 'sign-in', pathMatch: 'full', redirectTo: 'auth/sign-in' },
    { path: 'registro', pathMatch: 'full', redirectTo: 'auth/sign-up' },

    // Redirects to sign-in
    { path: '**', pathMatch: 'full', redirectTo: 'auth/sign-in' },
];
